import 'alpinejs'
  // import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
  // import Swiper styles
import 'swiper/swiper-bundle.css';

import moment from 'moment';

import Cleave from 'cleave.js';

document.addEventListener("DOMContentLoaded", function() {
  const today = moment().format();
  console.log(today);
  Array.from(document.querySelectorAll('.event').forEach((e) => {
    let dateString = e.getAttribute('data-date');
    let date = moment(dateString, 'DD/MM/YYYY', true).format();
    console.log(date);
    let a = e.querySelector('a');

    if (moment().diff(date, 'days') > 1) {
      console.log('Yeah');
      console.log(a);
      e.classList.add('opacity-30');
      e.classList.remove('opacity-100');
      a.classList.add('pointer-events-none');
    }
    else {
      console.log('No');
    }
  })
  );
});

/* eslint-disable no-unused-vars */
var swiper = new Swiper('.swiper-header', {
    resistance: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  var swiper2 = new Swiper('.swiper-secondary', {
    loop: true,
    spaceBetween: 24,
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.swiper-next',
    },
  });

  var swiper3 = new Swiper('.swiper-events', {
    resistance: false,
    centerInsufficientSlides: true,
    slidesPerView: 4,
    slidesPerGroup: 4,
    direction: 'vertical',
    slideClass: 'swiper-slide-secondary',
    pagination: {
      el: '.swiper-events-pagination',
      bulletClass: 'swiper-events-bullet',
      bulletActiveClass: 'swiper-events-bullet-active',
      clickable: true,
    },
  });

  var cleave = new Cleave('.formatMe', {
    delimiters: [':', ' ', '/'],
    blocks: [2, 2, 2, 2],
    uppercase: true
});
/* eslint-enable no-unused-vars */

